// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3YE0t","title":"Images45_title__AYyG5","images":"Images45_images__1RSDr"};